import { render, staticRenderFns } from "./ReasonForScheduling.vue?vue&type=template&id=2250f25e"
import script from "./ReasonForScheduling.vue?vue&type=script&lang=ts"
export * from "./ReasonForScheduling.vue?vue&type=script&lang=ts"
import style0 from "./ReasonForScheduling.vue?vue&type=style&index=0&id=2250f25e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports